var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAffiliateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_822_926",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H70V70H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_822_926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6016 18.0317L18.9578 32.5492M38.1151 51.7132L52.6393 56.0695",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.25 36.4168L53.9266 16.7402",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.125C8 13.798 8.13256 14.4645 8.39012 15.0863C8.64767 15.708 9.02518 16.273 9.50108 16.7489C9.97698 17.2248 10.542 17.6023 11.1637 17.8599C11.7855 18.1174 12.452 18.25 13.125 18.25C13.798 18.25 14.4645 18.1174 15.0863 17.8599C15.708 17.6023 16.273 17.2248 16.7489 16.7489C17.2248 16.273 17.6023 15.708 17.8599 15.0863C18.1174 14.4645 18.25 13.798 18.25 13.125C18.25 12.452 18.1174 11.7855 17.8599 11.1637C17.6023 10.542 17.2248 9.97698 16.7489 9.50108C16.273 9.02518 15.708 8.64767 15.0863 8.39012C14.4645 8.13256 13.798 8 13.125 8C12.452 8 11.7855 8.13256 11.1637 8.39012C10.542 8.64767 9.97698 9.02518 9.50108 9.50108C9.02518 9.97698 8.64767 10.542 8.39012 11.1637C8.13256 11.7855 8 12.452 8 13.125Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4219 13.125C52.4219 14.4842 52.9618 15.7878 53.923 16.7489C54.8841 17.71 56.1876 18.25 57.5469 18.25C58.9061 18.25 60.2097 17.71 61.1708 16.7489C62.1319 15.7878 62.6719 14.4842 62.6719 13.125C62.6719 11.7658 62.1319 10.4622 61.1708 9.50108C60.2097 8.53995 58.9061 8 57.5469 8C56.1876 8 54.8841 8.53995 53.923 9.50108C52.9618 10.4622 52.4219 11.7658 52.4219 13.125Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4219 57.542C52.4219 58.9012 52.9618 60.2048 53.923 61.1659C54.8841 62.127 56.1876 62.667 57.5469 62.667C58.9061 62.667 60.2097 62.127 61.1708 61.1659C62.1319 60.2048 62.6719 58.9012 62.6719 57.542C62.6719 56.1828 62.1319 54.8792 61.1708 53.9181C60.2097 52.9569 58.9061 52.417 57.5469 52.417C56.1876 52.417 54.8841 52.9569 53.923 53.9181C52.9618 54.8792 52.4219 56.1828 52.4219 57.542Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 47.292C8 51.3697 9.61986 55.2804 12.5032 58.1638C15.3866 61.0471 19.2973 62.667 23.375 62.667C27.4527 62.667 31.3634 61.0471 34.2468 58.1638C37.1301 55.2804 38.75 51.3697 38.75 47.292C38.75 43.2143 37.1301 39.3036 34.2468 36.4202C31.3634 33.5369 27.4527 31.917 23.375 31.917C19.2973 31.917 15.3866 33.5369 12.5032 36.4202C9.61986 39.3036 8 43.2143 8 47.292Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateIcon);
export default __webpack_public_path__ + "static/media/affiliate-icon.540ed8e42ac54baed8a8f0507141cc91.svg";
export { ForwardRef as ReactComponent };